import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { FaresService } from 'app/shared/services/fares.service';
import { Passengers } from 'app/shared/models/passenger.model';
import { LoyaltyProgram } from 'app/my-greyhound/my-greyhound.service';

@Injectable()
export class PassengersService {

    constructor(private http: Http,
        private faresService: FaresService) {
    }

    getDefaultPassengersSelection(): Passengers {
        return <Passengers>{
            adults: 1,
            concessions: 0,
            accompaniedChildren: 0,
            infants: 0,
            nursedInfant: 0,
            seatedInfant: 0,
            concessionCard1: null,
            concessionCard2: null,
            requiresSpecialAssistance: false,
            specialAssistanceType: null
        };
    }
    isPassengersCombinationValid = (passengers) => {

        this.validatePassengersObject(passengers);

        const adults = passengers.adults,
            concessions = passengers.concessions,
            totalAdults = adults + concessions,
            accompaniedChildren = passengers.accompaniedChildren,
            totalChildren = accompaniedChildren,
            nursedInfant = passengers.nursedInfant,
            seatedInfant = passengers.seatedInfant,
            totalInfants = nursedInfant + seatedInfant;

        if (accompaniedChildren > 0 && totalAdults === 0) {
            throw new Error(`Accompanied Child' must travel with an 'Adult'`);
        }
        if (totalInfants > 0 && totalAdults === 0) {
            throw new Error(`Infant' must travel with an 'Adult'`);
        }
        if (totalAdults === 1) {
           
            if (totalInfants === 2 && (nursedInfant !== 1 || seatedInfant !== 1)) {
                throw new
                    Error('1 Adult and 2 Infants: 1 infant must be seated and 1 infant must be nursed');
            }
            if (totalInfants > 2 || passengers.infant > 2) {
                throw new Error(`No more than 2 'Infants' with a single 'Adult'`);
            }
        }
        if (totalInfants > 4) {
            throw new Error(`No more than 4 'Infants' total`);
        }
        if (nursedInfant > totalAdults) {
            throw new Error('Total of nursed infants cannot be higher than number of adults');
        }
        if (concessions > 2) {
            throw new Error(`Maximum of 2 'Concessions' allowed`);
        }
        if (totalAdults === 0) {
            throw new Error('At least one Adult or Concession must be booked');
        }
        if (adults > 0 && concessions > 0 && totalChildren > 0 && seatedInfant > 0) {
            throw new Error('Too many fare types. Maximum allowed is 3.');
        }
        return true;
    };
    getTotalSeatedPassengers(passengers): number | null {
        return !passengers
            ? null
            : (!!passengers.adults ? passengers.adults : 0) +
            (!!passengers.concessions ? passengers.concessions : 0) +
            (!!passengers.students ? passengers.students : 0) +
            (!!passengers.accompaniedChildren ? passengers.accompaniedChildren : 0) +
            (!!passengers.seatedInfant ? passengers.seatedInfant : 0);
    };

    getPassengerDetails(customerGuid: string): Observable<any> { // TODO change to corresponding class
        const url = `/umbraco/api/Passenger/GetPassengerDetails/${customerGuid}`;
        return this.http.get(url);
    }

    getLoyaltyTripStatus(customerGuid, fareGuid, travelGuid): Observable<LoyaltyTripStatusResponse> {
        const url = `/umbraco/api/Passenger/GetLoyaltyTripStatus`,
            options = {
                CustomerGuid: customerGuid,
                FareGuid: fareGuid,
                TravelGuid: travelGuid
            };
        return this.http.post(url, options)
            .map(r =>
                Object.assign(new LoyaltyTripStatusResponse, r.json()));
    }


    private validatePassengersObject = (passengers) => {
        const requiredProperties = [
            'adults',
            'concessions',
            'accompaniedChildren',
            'nursedInfant',
            'seatedInfant'
        ];

        if (!passengers || !_.isObject(passengers)) {
            throw new Error('Passengers object is required');
        }

        for (let i = 0; i < requiredProperties.length; i++) {
            const prop = requiredProperties[i];
            if (!_.isNumber(passengers[prop])) {
                throw new Error(`'${prop}' is required`);
            }
        }
        return true;
    };
}

export class LoyaltyTripStatusResponse {
    CustomerLinkedToProgram: boolean;
    FreeTripAvailable: boolean;
    TripStatusDescription: string;
    LoyaltyProgramDescription: string;
    LoyaltyPrograms: Array<LoyaltyProgram>;
    CustomerEligibleTrip: boolean;
    ProgramEligibleTrip: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/services/passenger.service.ts